module.exports = __webpack_public_path__ + "img/Left-header-about-page.b6ddab9.svg";